<label class="custom-checkbox">
    <input type="checkbox" [checked]="check == true" (click)="checkUpdate()" />
    <span class="checkmark"></span>
    <span><ng-content></ng-content></span>
</label>